export default "__VITE_ASSET__CznduhhN__"